import React, { useEffect } from "react";

import { AnimationFadeToggle } from "../../utils";

export const ModalBenefitDetail = ({ benefit, onCloseModal }) => {
    //Habilitar y deshabilitar scroll
    useEffect(() => {
        if (benefit) {
            document.body.style.overflow = "hidden";
            return () => {
                document.body.style.overflow = null;
            };
        }
    }, [benefit]);
    return (
        <AnimationFadeToggle isOpen={benefit}>
            {benefit && (
                <section className='modal modal-benefit-detail modal-accessory-detail'>
                    <div className='main-container'>
                        <div className='modal-box'>
                            <div
                                className='close-button icon close'
                                id='close-modal'
                                onClick={onCloseModal}></div>
                            <div className='modal-header'>
                                <div className='modal-title'>
                                    <div className='left-title'>
                                        {/* NOMBRE */}
                                        {benefit.name && (
                                            <h1>{benefit.name}</h1>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='modal-body'>
                                <div className='modal-left'>
                                    <div className='description'>
                                        <b>Descripción</b>

                                        <p>
                                            {benefit.description &&
                                                benefit.description}
                                        </p>

                                        {benefit.since && benefit.until && (
                                            <>
                                                <br />
                                                <p>
                                                    Vigencia del {benefit.since}{" "}
                                                    al {benefit.until}
                                                </p>
                                            </>
                                        )}
                                    </div>
                                    <div
                                        className='description'
                                        style={{ marginBottom: 0 }}>
                                        <b>Ubicaciones</b>
                                        {benefit.location &&
                                            benefit.location.map((location) => (
                                                <p key={location.id}>
                                                    {location.location}
                                                </p>
                                            ))}
                                    </div>
                                </div>
                                <div className='modal-right'>
                                    <div className='modal-right__img-container'>
                                        {benefit.image && (
                                            <img
                                                className='accessory-image'
                                                src={benefit.image}
                                                alt={benefit.name}
                                            />
                                        )}
                                    </div>

                                    <ul className='benefit__social-networks'>
                                        {benefit.links &&
                                            benefit.links.map((link) => (
                                                <li key={link.id}>
                                                    <a
                                                        href={link.url}
                                                        target='_blank'>
                                                        <img src={link.icon} />
                                                    </a>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>

                            <div className='modal-footer modal-footer-benefit'>
                                <div className='legals-list-container'>
                                    <p className='text-legal'>
                                        (*) Promoción válida del {benefit.since}{" "}
                                        al {benefit.until}. Precios sugeridos.
                                    </p>
                                </div>
                                <div className='btn-container'>
                                    <a
                                        className='btn black'
                                        href='https://qr.codes/A3Kvlw'
                                        target='_blank'>
                                        Ir a la app
                                    </a>
                                    <button
                                        className='btn outline-black'
                                        onClick={onCloseModal}>
                                        Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </AnimationFadeToggle>
    );
};
